import { render, staticRenderFns } from "./AdunitWrapper.vue?vue&type=template&id=25432f13&scoped=true&"
import script from "./AdunitWrapper.vue?vue&type=script&lang=ts&"
export * from "./AdunitWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25432f13",
  null
  
)

export default component.exports